<template>
  <div>
    <v-text-field
      v-model.number="precioCostoLocal"
      id="precioCosto"
      v-validate="'required|decimal:2|max:30'"
      :error-messages="errors.collect('precioCosto')"
      data-vv-name="precioCosto"
      label="Precio de costo"
      :prefix="precioCostoLocal ? '$' : ''"
      type="number"
      required
      :outlined="outlined"
      :append-outer-icon="appendOuterIcon ? iconButton : ''"
      @input="onInputChange"
      @click:append-outer="clickAppendOuter"
    />
  </div>
</template>

<script>
export default {
  name: "form.producto.precio.costo",
  inject: ["$validator"],

  props: {
    producto: {
      type: Object,
      required: false,
    },
    precioCosto: {
      type: Number,
      required: false,
      default: 0
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    appendOuterIcon: {
      type: Boolean,
      default: false,
    },
    iconButton: {
      type: String,
      default: 'mdi-send',
    },
  },

  data() {
    return {
      precioCostoLocal: this.precioCosto ?? 0, // Si es null, usar 0
    };
  },

  watch: {
    // Si el padre actualiza precioCosto, actualizamos el local
    precioCosto(newVal) {
      this.precioCostoLocal = newVal ?? 0;
    }
  },

  methods: {
    onInputChange(valor) {
      // Emitimos el nuevo valor al padre
      this.$emit('update:precioCosto', valor);
    },
    clickAppendOuter() {
      this.$emit('click-button-append');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
